module.exports = __webpack_public_path__ + "assets/img/SEOClarity-Landing-Page-+-Website-w960.5fc07752.jpg";